<template>
	<div data-tour-scope="fic-orders">
		<v-navigation-drawer v-model="navStateFilter" fixed :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%">
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer />
			</v-card-title>
			<v-list dense />
		</v-navigation-drawer>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Fattureincloud Order</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer />
						</v-toolbar>


						<v-data-table
							v-if="Array.isArray(getOrders) && getOrders.length > 0"
							data-tour="table"
							:options.sync="settings.options"
							:headers="headers"
							:items="getOrders"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:item-class="itemRowBackground"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template #body="{ items }">
								<!-- telefono: ogni documento diventa una card chiave/valore con lo stato di sincronizzazione -->
								<tbody v-if="mobileCards" class="fic-cards">
									<tr v-for="item in items" :key="item._id || item.id" :data-tour="item.sync ? 'row-synced' : 'row-new'">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :class="{ 'fic-synced': item.sync }" :title="item.entity_name || 'Documento'" :fields="campiCard(item)">
												<template #actions>
													<v-menu top eager>
														<template #activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" data-tour="row-menu" v-on="on">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item v-if="!item.sync" link data-tour="fic-sync" @click="sincronizzaOrdine(item)">
																<v-list-item-title class="size9"> Sincronizza ordine </v-list-item-title>
															</v-list-item>
															<v-list-item v-else link data-tour="fic-detail" @click="dettaglioOrdine(item)">
																<v-list-item-title class="size9"> Dettaglio sincronizzazione </v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template #top>
													<v-chip x-small label :color="item.sync ? 'success' : 'grey lighten-2'" :text-color="item.sync ? 'white' : 'grey darken-3'" class="mb-2">
														{{ item.sync ? 'Sincronizzato' : 'Da sincronizzare' }}
													</v-chip>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :class="item.sync ? 'classSuccess' : ''" :data-tour="item.sync ? 'row-synced' : 'row-new'">
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template #activator="{ on, attrs }">
														<v-btn icon dark v-bind="attrs" color="primary" dense data-tour="row-menu" v-on="on">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item v-if="!item.sync" link data-tour="fic-sync" @click="sincronizzaOrdine(item)">
															<v-list-item-title class="size9"> Sincronizza ordine </v-list-item-title>
														</v-list-item>
														<v-list-item v-else link data-tour="fic-detail" @click="dettaglioOrdine(item)">
															<v-list-item-title class="size9"> Dettaglio sincronizzazione </v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>

											<td>{{ item.date | moment('DD/MM/YYYY') }}</td>
											<td>
												{{ item.id }}
											</td>
											<td>
												{{ item.entity_name }}
											</td>
											<td>
												{{ item.description }}
											</td>
											<td>
												{{ item.amount_out }}
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormSync v-if="operation === 'FormSync'" :key="componentKey" @message="propSetMessages" />
			<FormDetail v-if="operation === 'FormDetail'" :key="componentKey" @message="propSetMessages" />
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';

const FormSync = () => import('@/components/fattureincloud/Sync.vue');
const FormDetail = () => import('@/components/fattureincloud/Detail.vue');
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createFicOrdersTourSteps, stopFicOrdersTour } from './fic-orders-tour';

export default {
	name: 'Order',
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createFicOrdersTourSteps(), { onStop: stopFicOrdersTour }),
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},
	components: {
		FormSync,
		FormDetail,
		TourOverlay,
		KeyValueCard,
	},
	data() {
		return {
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,
			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					preparation_date: [],
					payments: [],
					agents: [],
				},
				options: {
					sortBy: ['date'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100, 250, 500, 750, 1000],
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '' },

				{ text: 'Data', value: 'created_at' },
				{ text: 'Id', value: 'id' },
				{ text: 'Entity', value: 'entity_name' },

				{ text: 'Description', value: 'description' },
				{ text: 'Amount', value: 'mount_out' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
		};
	},
	watch: {
		settings: {
			handler(val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.options.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.options.page;
				/*if(this.setinterval){
                        clearInterval(this.setinterval)
                    }*/
				this.getDataFromApi();
			},
			deep: true,
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSetting());
		promises.push(this.fetchService(['fattureInCloud']));

		await Promise.all(promises);
		this.setPreload(false);

		let fattureincloud = _.find(this.getServices, { service: 'fattureInCloud', active: true });
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		this.getDataFromApi();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'fattureincloud/getItems',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'fattureincloud/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'fattureincloud/getSortBy',
			getSortDesc: 'fattureincloud/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getServices: 'services/getServices',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
	},
	methods: {
		// stessi dati delle colonne della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Data', value: item.date ? this.$moment(item.date).format('DD/MM/YYYY') : '' },
				{ label: 'Id', value: item.id },
				{ label: 'Descrizione', value: item.description },
				{ label: 'Importo', value: item.amount_out, strong: true },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'fattureincloud/setItem',
			setIndex: 'fattureincloud/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
		}),
		...mapActions({
			fetchOrders: 'fattureincloud/asyncFetchData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			getOrdersReview: 'orders/getOrdersReview',
			fetchPackagings: 'packagings/getListings',
			fetchService: 'services/getServiceFetch',
		}),
		async propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},

		itemRowBackground(item) {
			return item.sync ? 'classSuccess' : 'classNothing';
		},

		async sincronizzaOrdine(item) {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormSync';
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async dettaglioOrdine(item) {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormDetail';
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				this.settings.filters.enableAgents = false;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
					this.selectedchecbox = [];
					this.selectedall = [];
				});
			} catch (err) {
				console.log(err);
			}
		},
	},

	// `beforeUnmount` e il nome del hook di Vue 3: su Vue 2 non scatta mai, quindi
	// `destroyData` qui non viene chiamato. Lasciato com era: non e un problema del
	// tutorial, ma il suo `stop` va messo in un hook che esiste davvero.
	beforeUnmount() {
		this.destroyData();
	},
	beforeDestroy() {
		this.tour.stop();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.fic-cards,
.fic-cards tr {
	display: block;
	width: 100%;
}
.fic-cards tr,
.fic-cards tr:hover {
	background: transparent !important;
}
.fic-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.fic-cards tr:first-child td {
	padding-top: 12px !important;
}
.fic-cards tr:last-child td {
	padding-bottom: 12px !important;
}
/* documento gia' sincronizzato: bordo sinistro verde, come la riga evidenziata in tabella */
.fic-synced {
	border-left: 4px solid #4caf50 !important;
}
</style>
